/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaDatePicker/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Children from 'Simple/Children'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaDatePicker({
  children,
  viewPath = "/DesignSystem/TysiaDatePicker",
  innerRef
  
}) {
let dtTysiainputdatepickerBackgroundcolorPrimaryBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaInputDatePicker.backgroundColor.primary.base'
        })
let dtTysiainputdatepickerBordercolorPrimaryBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaInputDatePicker.borderColor.primary.base'
        })
  return (<React.Fragment
>
<div
  data-testid="TysiaDatePicker.Vertical"
  data-view-path={viewPath}
 ref={innerRef}
 style={{'--bc-1-Z2pPTnO': dtTysiainputdatepickerBackgroundcolorPrimaryBase,'--bc-2-Z2pPTnO': dtTysiainputdatepickerBordercolorPrimaryBase}}
 className={`views-block new-shadow ${styles.Vertical}`}
>
<Children
  viewPath={`${viewPath}/Children`}
>
{children}
</Children>
</div>
</React.Fragment>)
}